import React from "react"
import types from "prop-types"
import clsx from "clsx"
import { useCustomName } from "hooks"
import { workflowActionShape } from "utils/propTypeShapes"
import { DEPARTMENT_KEY, FACILITY_KEY } from "utils/customNameHelpers"
import {
  actionSubtypeLabel,
  actionTypeLabel,
  DEFAULT_SUBTYPE,
  subtypeConnectorText,
} from "utils/workflowHelpers"

const DefaultActionLabel = ({ action, className = "" }) => {
  const { type, subtype } = action

  const facility = useCustomName(FACILITY_KEY)
  const department = useCustomName(DEPARTMENT_KEY)

  const customNames = { facility, department }

  return (
    <div className={clsx(className, "flex items-center screenreader-whitespace")}>
      {
        type && (
          <span className="workflow-white-label mr-2">{actionTypeLabel(type, customNames)}</span>
        )
      }
      {
        subtype && subtype !== DEFAULT_SUBTYPE && (
          <>
            <span className="mr-2 screenreader-whitespace">{subtypeConnectorText(type)}</span>
            <span className="workflow-white-label">{actionSubtypeLabel(subtype, customNames)}</span>
          </>
        )
      }
    </div>
  )
}

DefaultActionLabel.propTypes = {
  action: workflowActionShape.isRequired,
  className: types.string,
}

export default DefaultActionLabel
